module.exports = __webpack_public_path__ + "static/media/carnival_style_rendering_for_bbq_restaurant_2_2016.7f70c2eb.webp";